/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

interface IInputPasswordProps extends Omit<ChakraInputProps, 'size'> {
  name: string;
  label?: string;
}

export const InputPassword: React.FC<IInputPasswordProps> = ({
  name,
  label,
  ...rest
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormControl isInvalid={!!errors[name]}>
      {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
      <InputGroup>
        <ChakraInput
          id={name}
          {...register(name)}
          {...rest}
          type="password"
          bg="white"
        />
        <InputRightElement>
          <Icon
            as={showPassword ? EyeOffIcon : EyeIcon}
            color="gray.500"
            cursor="pointer"
            onClick={() => setShowPassword(!showPassword)}
          />
        </InputRightElement>
      </InputGroup>
      <FormErrorMessage>
        {errors?.[name] && (errors[name]?.message as string)}
      </FormErrorMessage>
    </FormControl>
  );
};
